import React, { useEffect } from 'react';
import { PublicationConfirmationFeature } from './publicationConfirmation';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { CATEGORIES } from '@app/src/config/categories';
import { setUserPasarella } from '@app/src/common/session';

export const StepThree: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];
  const urlPrintConsume = categoryConfig.paths.consumePackage.stepSummary;
  const urlPrintPurchase = categoryConfig.paths.purchasePrint.stepSummary;

  useEffect(() => {
    let typeAction = null;
    const currentUrl = `/${location.pathname.split('/')[1]}`;
    if (urlPrintConsume === currentUrl) {
      typeAction = 'consume-print';
    }
    if (urlPrintPurchase === currentUrl) {
      typeAction = 'purchase-print';
    }
    dispatch(setUserPasarella(typeAction));
  }, []);

  return (
    <React.Fragment>
      <PublicationConfirmationFeature />
    </React.Fragment>
  )
};
